import styled from 'styled-components'
import { TOPBAR_MOBILE_HEIGHT } from '@/v2/constants'

export const Container = styled.div`
  position: fixed;
  top: ${TOPBAR_MOBILE_HEIGHT};
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  z-index: 101;
  box-sizing: border-box;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  margin: 0;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 16px 32px;
  }
`

export const Content = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  padding-bottom: 100px;
`

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px;
  padding-left: calc(16px + env(safe-area-inset-left));
  padding-right: calc(16px + env(safe-area-inset-right));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #eee;
  z-index: 102;
`
